import { render, staticRenderFns } from "./HomeTournamentItem.vue?vue&type=template&id=76d524ac&"
import script from "./HomeTournamentItem.vue?vue&type=script&lang=js&"
export * from "./HomeTournamentItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports